<template>
  <div class="home_container">
    <div class="home_top">
      <div style="width: 1200px;margin: 0 auto;position: relative">
        <div style="position: relative;display: flex;flex-direction: row;align-items: center;margin-top: 40px">
          <div style="display: flex;flex-direction: row;align-items: center;">
            <img src="../assets/logo1.png" style="width: 190px;height: auto;">
          </div>
          <div style="position: absolute;right: 0;display: flex;flex-direction: row;align-items: center;">
            <p @click="goDown" class="header-item-title" :style="createHeaderTitleBorder('download')">
              下载witmaker</p>
<!--            <p @click="goAbout" class="header-item-title" :style="createHeaderTitleBorder('aboutUs')">-->
<!--              关于我们 </p>-->
            <p @click="goProtocol" class="header-item-title" :style="createHeaderTitleBorder('protocol')">
              隐私条款</p>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 100%;background-color: #F2F8FD;" id="about-card">
      <div class="note_content">
        <div style="display: flex;flex-direction: row;">
          <div class="content-card_1">
            <p class="intro_card_title">在拼贴中探索课外知识</p>
          </div>
          <div class="content-card_2">
            <p class="intro_card_title">智能扫码判对解锁成就</p>
          </div>
          <div class="content-card_3">
            <p class="intro_card_title">欣赏成画乐趣回味无穷</p>
          </div>
        </div>
      </div>
    </div>

    <div class="download-bg" id="download-view">
      <div style="position: absolute;right: 18.8vw;top: 19vw;display: flex;flex-direction: column">
        <img src="../assets/download_logo.png" style="width: 30vw;height: auto">
        <canvas id="qrcode" style="width: 18vw;height: 18vw;margin-top: 15px"></canvas>
      </div>
    </div>
    <div style="width: 100%;height: 300px;background-color: white"/>
  </div>
</template>
<script>
import QRCode from 'qrcode'
import scroll from "../utils/scroll";
import Cookies from 'js-cookie'

export default {
  name: 'Home',
  data() {
    return {
      currentSelectTitle:'download'
    }
  },
  mounted() {
    var index = Cookies.get('index');
    if(index == null || index == ''){
      this.currentSelectTitle = 'download'
    } else {
      this.currentSelectTitle = index
    }
    QRCode.toCanvas(document.getElementById('qrcode'), 'https://itunes.apple.com/cn/app/id1614957119?mt=8', function (error) {
      if (error) console.error(error)
      console.log('success!');
    })
  },
  methods: {
    createHeaderTitleBorder(value) {
      var style = {}

      if(this.currentSelectTitle == value){

        style.borderColor = '#0076CB'

      }else {

        style.borderColor = '#ffffff'
      }

      return style
    },
    goProtocol(){

      this.currentSelectTitle ='protocol'
      Cookies.set('index','protocol');

      this.$router.push('/protocol')
    },
    goAbout() {
      this.currentSelectTitle ='aboutUs'
      Cookies.set('index','aboutUs');
      // var about_card = document.getElementById("about-card")
      // var offsetTop = about_card.offsetTop
      // scroll(0, offsetTop)
      // window.scrollTo(0, offsetTop)
    },
    goDown() {
      this.currentSelectTitle ='download'
      Cookies.set('index','download');
      var download_view = document.getElementById("download-view")
      var offsetTop = download_view.offsetTop
      scroll(0, offsetTop)
      // window.scrollTo(0, offsetTop)
    }
  }
}
</script>

<style scoped lang="scss">

.header-item-title {
  cursor: pointer;
  margin: 0 45px 0 0;
  color: #1868B4;
  font-size: 21px;
  font-weight: 500;
  border-color: #0076CB;
  padding: 0 0 4px 0;
  border-right-width: 0px;
  border-top-width: 0px;
  border-left-width: 0px;
  border-bottom-width: 0.2vw;
  border-style: solid;
}

.content-card_1{
  position: relative;
  background-image: url("../assets/intro_card_1.png");
  background-repeat: no-repeat;
  width:411px;
  height: 595px;
}
.content-card_2{
  position: relative;
  background-image: url("../assets/intro_card_2.png");
  background-repeat: no-repeat;
  width:411px;
  height: 595px;
}
.content-card_3{
  position: relative;
  background-image: url("../assets/intro_card_3.png");
  background-repeat: no-repeat;
  width:411px;
  height: 595px;
}

.intro_card_title {
  width: 100%;
  padding: 0;
  margin: 0;
  color: #0076CB;
  font-size: 28px;
  font-weight: bold;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 133px;
}

.home_container {
  max-width: 1920px;
}

.download-bg {
  position: relative;
  background-image: url("../assets/download_bg.png");
  background-repeat: no-repeat;
  background-position: 100% 100%;
  background-color: transparent;
  background-size: contain;
  width: 100%;
  height: 56vw;
}

.home_top {
  background-image: url("../assets/home_bg.png");
  background-repeat: no-repeat;
  background-position: 100% 100%;
  background-color: transparent;
  background-size: contain;
  width: 100%;
  height: 56vw;
}



.intro_card_content {
  text-align: left;
  color: #030303;
  font-size: 18px;
  font-family: "PingFang SC";
  font-weight: 300;
  line-height: 34px;
}

.creater_intro {
  color: #555555;
  font-size: 24px;
  font-family: "PingFang SC";
  line-height: 50px;
  font-weight: 300;
}

.note_content {
  z-index: 1;
  text-align: center;
  width: 1200px;
  margin: 0 auto;
  position: relative;
  padding-top: 146px;
  padding-bottom: 146px
}

.update_circle {
  width: 17px;
  height: 17px;
  border: 1px solid #666666;
  border-radius: 50%;
}

.update_log_text {
  margin: 0 0 0 42px;
  color: #555555;
  font-size: 24px;
  font-family: "PingFang SC";
}
</style>